import { IonSkeletonText } from '@ionic/react';

import styles from '@components/explore/Explore.module.css';
import loaderStyles from '@components/loaders/LoaderStyles.module.css';

const HeaderCard = () => (
  <div className={loaderStyles.fullWidth}>
    <IonSkeletonText animated className={loaderStyles.skeletonHeaderCard} />
    <div className={styles.headerText + ' ' + styles.hideMobile}>
      <IonSkeletonText animated className={loaderStyles.skeletonHeading2} />
    </div>
  </div>
);

const ExploreHeaderLoader = () => (
  <div className={styles.headerCards}>
    <HeaderCard />
    <HeaderCard />
    <HeaderCard />
    <HeaderCard />
  </div>
);

export default ExploreHeaderLoader;
